// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Cxsu","row":"Node_row__seJe1","label":"Node_label__2i_BJ","footer":"Node_footer__2NHaq"};